import { render, staticRenderFns } from "./BackupRestoreConfirm.vue?vue&type=template&id=03d27bb1&"
import script from "./BackupRestoreConfirm.vue?vue&type=script&lang=js&"
export * from "./BackupRestoreConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports